// extracted by mini-css-extract-plugin
module.exports = {"MenuToggle":"MenuToggle_MenuToggle__xusEm","open":"MenuToggle_open__3bFG3"};